import React from 'react';
import type { IconProps } from '../types';

export const IconDOM: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Depth of Market - ladder/depth chart */}
    <rect x="2" y="3" width="16" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    {/* Bid side (left) - bars */}
    <rect x="4" y="6" width="4" height="1.5" fill={color} fillOpacity="0.7"/>
    <rect x="4" y="9" width="5" height="1.5" fill={color} fillOpacity="0.5"/>
    <rect x="4" y="12" width="3" height="1.5" fill={color} fillOpacity="0.3"/>
    {/* Ask side (right) - bars */}
    <rect x="12" y="6" width="4" height="1.5" fill={color} fillOpacity="0.3"/>
    <rect x="11" y="9" width="5" height="1.5" fill={color} fillOpacity="0.5"/>
    <rect x="13" y="12" width="3" height="1.5" fill={color} fillOpacity="0.7"/>
    {/* Center line */}
    <line x1="10" y1="5" x2="10" y2="15" stroke={color} strokeWidth="1.5" strokeDasharray="2 2"/>
  </svg>
);
